import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasInvoiceSchema = withDefaults({
  type: 'tas-invoice',
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'invoiceType',
    },
    {
      kind: 'attribute',
      name: 'fundingType',
    },
    {
      kind: 'attribute',
      name: 'origin',
    },
    {
      kind: 'attribute',
      name: 'invoiceDate',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'paidAt',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasInvoiceSchema;
